var map = {
	"./antelope.png": 800,
	"./baboon.png": 881,
	"./buffalo.png": 980,
	"./cheetah.png": 190,
	"./elephant.png": 552,
	"./giraffe.png": 505,
	"./hippo.png": 300,
	"./horse.png": 46,
	"./hyena.png": 241,
	"./kangaroo.png": 118,
	"./lion.png": 605,
	"./llama.png": 177,
	"./meerkat.png": 790,
	"./oryx.png": 717,
	"./ostrich.png": 648,
	"./rat.png": 36,
	"./rhino.png": 607,
	"./warthog.png": 415,
	"./wildebeast.png": 861,
	"./zebra.png": 613
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 872;